import React from 'react'
import TextField from '../../../baseApp/shared/components/fields/textField/TextField';
import { I18n } from 'react-redux-i18n';
import DateTimeUtils from './../../../baseApp/shared/utils/DateTimeUtils';
import SelectField from './../../../baseApp/shared/components/fields/selectField/SelectField';
import { PropTypes } from 'prop-types';
import SwitchField from '../../../baseApp/shared/components/fields/switchField/SwitchField';
import FormDivider from './../../../baseApp/shared/components/others/Divider';
import TimeField from './../../../baseApp/shared/components/fields/dateTime/TimeField';
import CreatableMultiSelectTextInput from './../../../baseApp/shared/components/fields/selectField/CreatableMultiSelectTextInput';

const BuildingSubForm = ({
    latitude,
    longitude,
    address,
    zipCode,
    parish,
    city,
    country,
    timezone,
    accessInformation,
    // Building Check-In Configuration
    hasCheckInConfiguration,
    domain,
    enableNotification,
    autoCheckOutDelay,
    operationTimeStart,
    operationTimeEnd,
    // ------
    viewMode,
    handleFieldBlur,
    handleFieldChange
}) => {
    const timeZoneData = DateTimeUtils.getTimezoneDataForDropdown();

    return <div id="building-sub-form">
        <div className="field-row">
            <div className="row">
                <TextField
                    value={latitude.value}
                    error={latitude.error}
                    label={I18n.t("subForms.field.latitude")}
                    handleFieldChange={value => handleFieldChange("latitude", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
                <TextField
                    value={longitude.value}
                    error={longitude.error}
                    label={I18n.t("subForms.field.longitude")}
                    handleFieldChange={value => handleFieldChange("longitude", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
            </div>
            <div className="row">
                <TextField
                    value={address.value}
                    error={address.error}
                    label={I18n.t("subForms.field.address")}
                    handleFieldChange={value => handleFieldChange("address", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
                <TextField
                    value={zipCode.value}
                    error={zipCode.error}
                    label={I18n.t("subForms.field.zipCode")}
                    handleFieldChange={value => handleFieldChange("zipCode", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
            </div>
            <div className="row">
                <TextField
                    value={parish.value}
                    error={parish.error}
                    label={I18n.t("subForms.field.parish")}
                    handleFieldChange={value => handleFieldChange("parish", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
                <TextField
                    value={city.value}
                    error={city.error}
                    label={I18n.t("subForms.field.city")}
                    handleFieldChange={value => handleFieldChange("city", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
            </div>
            <div className="row">
                <TextField
                    value={country.value}
                    error={country.error}
                    label={I18n.t("subForms.field.country")}
                    handleFieldChange={value => handleFieldChange("country", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
                <SelectField
                    value={timezone.value}
                    error={timezone.error}
                    label={I18n.t("subForms.field.timezone")}
                    handleFieldChange={value => handleFieldChange("timezone", value)}
                    themeName="form"
                    options={timeZoneData}
                    disabled={viewMode}
                    width={4}
                />
            </div>
            <div className="row">
                <TextField
                    value={accessInformation.value}
                    error={accessInformation.error}
                    label={I18n.t("subForms.field.accessInformation")}
                    handleFieldChange={value => handleFieldChange("accessInformation", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
                <SwitchField
                    handleFieldChange={value => handleFieldChange("hasCheckInConfiguration", value)}
                    checked={hasCheckInConfiguration.value}
                    label={I18n.t("subForms.field.hasCheckInConfiguration")}
                    disabled={viewMode}
                    width={2}
                />
            </div>
        </div>
        <FormDivider display={hasCheckInConfiguration.value} />
        {buildCheckInConfigurationFields(
            hasCheckInConfiguration.value,
            domain,
            enableNotification,
            autoCheckOutDelay,
            operationTimeStart,
            operationTimeEnd,
            handleFieldChange,
            handleFieldBlur,
            viewMode
        )}
    </div>
};


function buildCheckInConfigurationFields(
    hasCheckInConfiguration,
    domain,
    enableNotification,
    autoCheckOutDelay,
    operationTimeStart,
    operationTimeEnd,
    handleFieldChange,
    handleFieldBlur,
    viewMode
) {
    return hasCheckInConfiguration && <React.Fragment>
        <div className="field-row">
            <div className="row">
                <TimeField
                    value={operationTimeStart.value}
                    error={operationTimeStart.error}
                    label={I18n.t("subForms.field.checkInConfiguration.operationTimeStart")}
                    handleFieldChange={value => handleFieldChange("operationTimeStart", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
                <TimeField
                    value={operationTimeEnd.value}
                    error={operationTimeEnd.error}
                    label={I18n.t("subForms.field.checkInConfiguration.operationTimeEnd")}
                    handleFieldChange={value => handleFieldChange("operationTimeEnd", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
            </div>
            <div className="row">
                <CreatableMultiSelectTextInput
                    value={domain.value}
                    error={domain.error}
                    label={I18n.t("subForms.field.checkInConfiguration.domain")}
                    placeholder={I18n.t("subForms.field.checkInConfiguration.domainPlaceholder")}
                    handleFieldChange={value => handleFieldChange("domain", value)}
                    themeName="form"
                    disabled={viewMode}
                    isCreatable={true}
                />
                <TextField
                    value={autoCheckOutDelay.value}
                    error={autoCheckOutDelay.error}
                    endAdornment={I18n.t("fields.units.hours")}
                    label={I18n.t("subForms.field.checkInConfiguration.autoCheckOutDelay")}
                    handleFieldChange={value => handleFieldChange("autoCheckOutDelay", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
            </div>
            <div className="row mt-2">
                <SwitchField
                    handleFieldChange={value => handleFieldChange("enableNotification", value)}
                    checked={enableNotification.value}
                    label={I18n.t("subForms.field.checkInConfiguration.enableNotification")}
                    disabled={viewMode}
                    width={4}
                />
            </div>
        </div>
    </React.Fragment>;
}

BuildingSubForm.propTypes = {
    timezone: PropTypes.object.isRequired
};

export default BuildingSubForm;